import { useState, type MouseEventHandler } from "react";
import { Badge } from "react-bootstrap";

interface Props {
  tag: string;
  onUpdate?: (tag: string) => void;
  onClick?: MouseEventHandler<HTMLElement>;
  actionType?: "add" | "remove";
  showActionIcon?: boolean;
}

const CustomTag = ({
  tag,
  onUpdate = () => {},
  onClick = () => {},
  actionType = "remove",
  showActionIcon = false,
}: Props) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Badge
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="badge bg-trellis-mauve d-flex"
      style={{
        marginRight: "1rem",
        cursor: "pointer",
      }}
      pill
      onClick={onClick}
    >
      {tag}
      <i
        onClick={() => onUpdate(tag)}
        className={`fa ${actionType === "add" ? "fa-plus" : "fa-close"} ps-1`}
        style={{
          width: "10px",
          position: "relative",
          display: isHovered || showActionIcon ? "inline" : "none",
        }}
      />
    </Badge>
  );
};

export default CustomTag;
